<p i18n>
  global-export works!
</p>
